import { render, staticRenderFns } from "./CouponDataItem.vue?vue&type=template&id=dffe00c0&scoped=true"
import script from "./CouponDataItem.vue?vue&type=script&lang=ts"
export * from "./CouponDataItem.vue?vue&type=script&lang=ts"
import style0 from "./CouponDataItem.vue?vue&type=style&index=0&id=dffe00c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffe00c0",
  null
  
)

export default component.exports